import React, { useState, Component } from "react";
import ReactDOM from "react-dom";
import MaterialTable from "@material-table/core";
import Footer from "../../../components/shared/Footer";
import { DocumentTypeRule } from "../../../models";
import AttorneySelect from "../../../components/shared/AttorneySelect";
import { DocumentRulesService } from "../../../services/ClientService";
import { useEffect } from "react";
import DocumentTypeRuleTestModal from "./../../../pages/queue/components/modals/DocumentTypeRuleTestModal";
import { Button } from "react-bootstrap";

export default function DocumentTypeRules() {
    const never = "never" as const;
    const [selectedAttorneyId, setSelectedAttorneyId] = useState("");
    const [selectedFirmId, setSelectedFirmId] = useState("");
    const [ruleModalShow, setRuleModalShow] = useState(false);

    const [data, setData] = useState([] as DocumentTypeRule[]);

    const refreshData = () => {
        if (selectedAttorneyId != "") {
            DocumentRulesService.getList({
                attorneyId: selectedAttorneyId!,
            }).then(
                (resp) => {
                    if (resp.successful && resp.data) {
                        setData(resp.data);
                    } else {
                        //TODO: Show error
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    useEffect(() => {
        if (selectedAttorneyId != "") {
            DocumentRulesService.getList({
                attorneyId: selectedAttorneyId!,
            }).then(
                (resp) => {
                    if (resp.successful && resp.data) {
                        setData(resp.data);
                    } else {
                        //TODO: Show error
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    }, [selectedAttorneyId]);
    const onAttorneySelected = (id: string, name: string) => {
        setSelectedAttorneyId(id);
    };

    const onFirmSelected = (id: string, name: string) => {
        setSelectedFirmId(id);
        setSelectedAttorneyId("");
        setData([]);
    };

    return (
        <div className="content">
            <DocumentTypeRuleTestModal
                show={ruleModalShow}
                attorneyId={selectedAttorneyId}
                onSubmit={() => setRuleModalShow(false)}
                onClose={() => setRuleModalShow(false)}
            />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Rules</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Admin</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Rules
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row m-2">
                    <div
                        className="col-sm-8"
                        style={{ maxWidth: "100%", zIndex: 50 }}
                    >
                        <AttorneySelect
                            onAttorneySelected={onAttorneySelected}
                            onFirmSelected={onFirmSelected}
                        />
                    </div>
                    <div className="col-sm-2" style={{ marginTop: "28px" }}>
                        {selectedAttorneyId && (
                            <Button
                                title="Test"
                                type="submit"
                                onClick={() => setRuleModalShow(true)}
                            >
                                Test
                            </Button>
                        )}
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div style={{ maxWidth: "100%", zIndex: 20 }}>
                            <MaterialTable
                                options={{
                                    pageSizeOptions: [5, 10, 20, 50, 75, 100],
                                }}
                                columns={[
                                    {
                                        title: "ID",
                                        field: "id",
                                        editable: never,
                                    },
                                    { title: "County", field: "county" },
                                    {
                                        title: "ePortal Division",
                                        field: "division",
                                    },
                                    { title: "Filename", field: "filename" },
                                    { title: "File Text", field: "fileText" },
                                    {
                                        title: "Min Amount",
                                        field: "minAmount",
                                        type: "numeric" as const,
                                    },
                                    {
                                        title: "Max Amount",
                                        field: "maxAmount",
                                        type: "numeric" as const,
                                    },
                                    {
                                        title: "Document Type",
                                        field: "documentType",
                                    },
                                    {
                                        title: "Description",
                                        field: "description",
                                        type: "string",
                                    },
                                    {
                                        title: "Security Type",
                                        field: "securityType",
                                    },
                                    {
                                        title: "Component",
                                        field: "component",
                                    },
                                    {
                                        title: "New Cases",
                                        field: "newCases",
                                        type: "boolean" as const,
                                    },
                                    {
                                        title: "Valid Until",
                                        field: "validUntil",
                                        type: "date" as const,
                                    },
                                    {
                                        title: "Active",
                                        field: "active",
                                        type: "boolean" as const,
                                    },
                                ]}
                                data={data}
                                title="Document Type Rules"
                                editable={{
                                    onRowAdd: (newData) =>
                                        new Promise((resolve, reject) => {
                                            DocumentRulesService.add({
                                                body: {
                                                    ...newData,
                                                    attorneyID:
                                                        selectedAttorneyId,
                                                    active: true,
                                                },
                                            }).then(
                                                (resp) => {
                                                    refreshData();
                                                    resolve(null);
                                                },
                                                (error) => {
                                                    console.log(error);
                                                    resolve(null);
                                                }
                                            );
                                        }),
                                    onRowUpdate: (newData, oldData) =>
                                        new Promise((resolve, reject) => {
                                            DocumentRulesService.update({
                                                id: oldData?.id ?? "",
                                                body: newData,
                                            }).then(
                                                (resp) => {
                                                    refreshData();
                                                    resolve(null);
                                                },
                                                (error) => {
                                                    console.log(error);
                                                    resolve(null);
                                                }
                                            );
                                        }),
                                    onRowDelete: (oldData) =>
                                        new Promise((resolve, reject) => {
                                            DocumentRulesService.delete({
                                                id: oldData.id ?? "",
                                            }).then(
                                                (resp) => {
                                                    refreshData();
                                                    resolve(null);
                                                },
                                                (error) => {
                                                    console.log(error);
                                                    resolve(null);
                                                }
                                            );
                                        }),
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
